/**
 * Opens a booking link in a new window and sends tracking data to the Adex server.
 *
 * This function is triggered when a user clicks on a showtime in the program.
 * Before redirecting to the ticket booking page, it sends tracking data to Adex
 * containing the film number (Filmnummer) and cinema location (Kinostandort).
 *
 * The Adex script is loaded dynamically and the data is pushed to the Adex queue
 * before the booking window is opened via window.open().
 *
 * @param {string} bookingLink - The URL to the ticket booking page
 * @param {string} target - The target window name for window.open()
 * @param {string|number} filmNumber - The film number (defaults to "1000" if not provided)
 * @param {string|number} location - The cinema location code, three-digit number (defaults to "1000" if not provided)
 */
function openBooking(bookingLink, target, filmNumber, location) {
  // Validate that all required data is provided
  if (!bookingLink) {
    console.error("openBooking: bookingLink is required");
    return;
  }

  if (!target) {
    console.error("openBooking: target is required");
    return;
  }

  // filmNumber and location are optional (will default to "1000")
  // but we log a warning if they're missing
  if (!filmNumber) {
    console.warn("openBooking: filmNumber is missing, will use default value");
  }
  if (!location) {
    console.warn("openBooking: location is missing, will use default value");
  }

  window._adexc = window._adexc || [];

  if (window._adexc) {
    const dataObj = {
      Filmnummer: filmNumber ?? "1000",
      Kinostandort: location ?? "1000",
    };

    console.log("dataObj for adex", dataObj);

    window._adexc.push(["/1999/8026/", "ut", "_kv", [dataObj, 1]]);

    var axd = document.createElement("script");
    axd.type = "text/javascript";
    axd.async = 1;
    axd.src = "https://dmp.theadex.com/d/1999/8026/s/adex.js";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(axd, s);
  }

  window.open(bookingLink, target);
}

window.openBooking = openBooking;

// create custom event listener with payload as alternative to trigger openBooking function
document.addEventListener("openBooking", (event) => {
  const payload = event.detail;

  if (!payload) {
    console.error("openBooking event: payload is missing");
    return;
  }

  openBooking(payload.bookingLink, payload.target, payload.filmNumber, payload.location);
});
